import React, { useEffect, useState } from "react";

// components
import HearroCommonTable from "../../../components/hearro/table/HearroCommonTable";
import CommonPagination from "../../../components/pagination/CommonPagination";
import CommonModal from "../../../components/modal/CommonModal";

// api
import { getPushMessageFromHearro, postPushMessageToHearro } from "../../../services/apis/hearro/message";

// utils
import { hasForbiddenChars, FORBIDDEN_CHARS_MSG, sanitizeText } from "../../../utils/sanitize";


const tableHeader = [
    {
        key: '보낸 사람',
        value: '보낸 사람'
    },
    {
        key: '기관명',
        value: '기관명'
    },
    {
        key: '부서명',
        value: '부서명'
    },
    {
        key: '발송 대상자',
        value: '발송 대상자'
    },
    {
        key: '성별',
        value: '성별'
    },
    {
        key: '훈련',
        value: '훈련'
    },
    {
        key: '내용',
        value: '내용'
    },
    {
        key: '발송일자',
        value: '발송일자'
    }
]

function HearroNotificationList() {
	const [pushMessageData, setPushMessageData] = useState([]);
	const [totalDataCnt, setTotalDataCnt] = useState(0);

	const [selectedPage, setSelectedPage] = useState(1);
	const [hasGenderClicked, setHasGenderClicked] = useState(false);

	const [inputSearchOption, setInputSearchOption] = useState({
		search: "",
		// 타겟팅 여부 -> T(타겟팅) / A(전체 사용자)
		target: "",
		// 성별 -> M / F
		sex: "",
		// 훈련 -> 10(시작 전), 20(정상), 30(미달), 40(정상), 45(탈락)
		training: ""
	})
	const [searchOption, setSearchOption] = useState({
		search: "",
		target: "",
		sex: "",
		training: ""
	});

	// 특정 메시지 클릭 시 나타나는 팝업 정보
	const [clickedMeassageInfo, setClickedMessageInfo] = useState({
		"발송 대상자": "",
		성별: "",
		훈련: "",
		내용: ""
	})
	const [showClickedMessageModal, setShowClickedMessageModal] = useState(false);


	async function getPushMessageFromAPI() {
		try{
			const request = {
				text: sanitizeText(searchOption.search),
				target: searchOption.target,
				sex: searchOption.sex === 'A' ? '' : searchOption.sex,
				training: searchOption.training,
				page: selectedPage
			};
			const res = await getPushMessageFromHearro(request);
			if(parseInt(res.status/200,10)===1){
                const convert = {
                    target : {
                        T : "타겟팅",
                        A : "전체 사용자"
                    },
                    training : {
                        10: "시작 전",
                        20: "정상",
                        30: "종료",
                        40: "미달",
                        45: "탈락"
                    },
                    sex : {
						A : "전체",
                        M : "남",
                        F : "여"
                    }
                }
				if(res.data.length>0){
					const newPushMessageList = res.data.map(e=>({
						'보낸 사람': e.stffName || "",
						기관명: e.instName || "",
						부서명: e.department || "",
						'발송 대상자': e.target ? convert.target[e.target] : "",
						성별: e.sex ? convert.sex[e.sex] : "전체",
						훈련: e.training ? e.training.split("|").map(el=>convert.training[el]).join("/") : "전체",
						내용: e.contents || "",
						발송일자: e.insDate ? e.insDate.split('T')[0] : ""
					}))
					setPushMessageData(newPushMessageList);
					setTotalDataCnt(res.data[0].totalCnt);
				}else{
					setPushMessageData([]);
					setTotalDataCnt(0);
				}
			}
		}catch(err){
			console.error(err);
		}
	}

	// 메시지 전송 Modal
	const [showRegisterNotificationModal, setShowRegisterNotificationModal] = useState(false);
	const [input,setInput] = useState({
		target: "",
		sex: "",
		training: "",
		message: ""
	});

	// 메시지 전송 성공 Modal
	const [showSuccessSendModal, setShowSuccessSendModal] = useState(false);


	// 검색 조건
	const resetSearchOption = () => {
		setHasGenderClicked(false);
		setInputSearchOption({
			search: "",
			target: "",
			sex: "",
			training: ""
		})
	}

	const applySearchOption = () => {
		if(hasForbiddenChars(inputSearchOption.search)) return;
		setSearchOption(inputSearchOption);
	}

	// inputSearchOption의 training 체크(다중 선택 가능)
	function handleCheckInputSearchOptionTraining(selectedTraining) {
		if(inputSearchOption.training){
			const curTrainingList = inputSearchOption.training.split("|");
			if(curTrainingList.includes(selectedTraining)){
				setInputSearchOption({
					...inputSearchOption,
					training: curTrainingList.filter(e=>e!==selectedTraining).join("|")
				})
			}else{
				setInputSearchOption({
					...inputSearchOption,
					training: [...curTrainingList,selectedTraining].sort((a,b)=>Number(a)-Number(b)).join("|")
				})
			}		
		}else{
			setInputSearchOption({
				...inputSearchOption,
				training: selectedTraining
			})
		}		
	}

	// 메시지 전송 성공 Modal
	const closeSuccessSendModal = () => {
		setShowSuccessSendModal(false);
	}

	const SuccessSendModalBody = <div className="modalbody">메시지를 성공적으로 전송하였습니다.</div>;

	const SuccessSendModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={closeSuccessSendModal}
				style={{ width: '100%' }}
			>
				확인
			</button>
		</div>
	);

	// 메시지 전송 Modal
	const closeRegisterNotificationModal = () => {
		setShowRegisterNotificationModal(false);
		setInput({
			target: "",
			sex: "",
			training: "",
			message: ""
		});
	}

	function getCurrentDateTime() {
        const now = new Date();
        
        // 년, 월, 일, 시, 분을 가져오기
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        
        // YYYYMMDDHH24MI 형식으로 조합하여 반환
        return `${year}${month}${day}${hours}${minutes}`;
    }

	async function registerNewNotification() {
		if(hasForbiddenChars(input.message)) return;
		if(!input.target || (input.target==="T" && Object.values(input).some(e=>e==="")) || (input.target==="A" && !input.message)){
			alert("모든 값을 입력해주세요.");
			return;
		}

		try{
            const currentDateStr = getCurrentDateTime();

			const request = {
				target: input.target,
				sex: input.sex,
				training: input.training,
				subject: "",
				contents: sanitizeText(input.message),
				sendDate: currentDateStr
			};
			const res = await postPushMessageToHearro(request);
			if(parseInt(res.status/200,10)===1){
				setShowSuccessSendModal(true);
				closeRegisterNotificationModal();
				getPushMessageFromAPI();
			}else{
				alert("메시지 전송에 실패하였습니다.");
			}			
		}catch(err){
			console.error(err);
			
		}
	}

	function handleCheckInputTraining(selectedTraining) {
		if(input.training){
			const curTrainingList = input.training.split("|");
			if(curTrainingList.includes(selectedTraining)){
				setInput({
					...input,
					training: curTrainingList.filter(e=>e!==selectedTraining).join("|")
				})
			}else{
				setInput({
					...input,
					training: [...curTrainingList,selectedTraining].sort((a,b)=>Number(a)-Number(b)).join("|")
				})
			}		
		}else{
			setInput({
				...input,
				training: selectedTraining
			})
		}		
	}

	// 메시지 전송 모달
	const RegisterNotificationModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">받는 사람</div>
				<div
					className="formModalItem__input"
					style={{width: '21.875rem', justifyContent: 'space-between'}}
				>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-all"
							type="radio"
							onChange={()=>setInput({
								...input,
								target: "A",
								sex: "A",
								training: ""
							})}
							checked={input.target==="A"}
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-all">전체 사용자</label>
					</div>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-targeting"
							type="radio"
							onChange={()=>setInput({
								...input,
								target: "T"
							})}
							checked={input.target==="T"}
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-targeting">타겟팅</label>
					</div>					
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">타겟 조건</div>
				<div>
					<div className="formModalItem__subItem" style={{ marginBottom: '1rem' }}>
						<div className="formModalItem__label">성별</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-male"
									type="radio"
									onChange={()=>setInput({
										...input,
										sex: "M"
									})}
									checked={input.sex==="M"}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-male">남</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-female"
									type="radio"
									onChange={()=>setInput({
										...input,
										sex: "F"
									})}
									checked={input.sex==="F"}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-female">여</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-all"
									type="radio"
									onChange={()=>setInput({
										...input,
										sex: "A"
									})}
									checked={input.sex==="A"}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-all">전체</label>
							</div>					
						</div>
					</div>
					<div className="formModalItem__subItem">
						<div className="formModalItem__label">훈련 <span>(중복체크 가능)</span></div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-10"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("10")}
									checked={input.training.split("|").includes("10")}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-10">시작 전</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-20"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("20")}
									checked={input.training.split("|").includes("20")}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-20">정상</label>
							</div>		
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width" />			
						</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-40"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("40")}
									checked={input.training.split("|").includes("40")}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-40">미달</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-45"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("45")}
									checked={input.training.split("|").includes("45")}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-45">탈락</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-30"
									type="checkbox"
									onChange={()=>handleCheckInputTraining("30")}
									checked={input.training.split("|").includes("30")}
									disabled={input.target==="A"}
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-30">종료</label>
							</div>					
						</div>
					</div>
				</div>				
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">메시지</div>
				<div className="formModalItem__input">
					<textarea
						type="text"
						className="formModalItem__input__textarea"
						placeholder="메시지 내용을 입력해주세요."
						value={input.message}
						onChange={e => setInput({ ...input, message: e.target.value })}
						maxLength={500}
						style={{ height: '12.5rem' }}
					/>
					{hasForbiddenChars(input.message) && (
						<div className="validation" style={{ color: '#DC3545', marginTop: '0.5rem' }}>
							{FORBIDDEN_CHARS_MSG}
						</div>
					)}
				</div>
			</div>
		</div>
	);

	const handleCheckSubmitDisabled = () => {
		if(input.target==="T"){
			return Object.values(input).some(e=>e==="");
		}else{
			return !(input.target && input.message);
		}
	}

	const RegisterNotificationModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={registerNewNotification}
				disabled={handleCheckSubmitDisabled()}
			>
				저장
			</button>
			<button className="cancelButton__rounded" onClick={closeRegisterNotificationModal}>
				취소
			</button>
		</div>
	);

	// 메시지 상세 보기 모달
	const closeClickedMessageModal = () => {
		setShowClickedMessageModal(false);
	}

	const ClickedMessageModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">받는 사람</div>
				<div
					className="formModalItem__input"
					style={{width: '21.875rem', justifyContent: 'space-between'}}
				>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-all"
							type="radio"
							checked={clickedMeassageInfo["발송 대상자"]==="전체 사용자"}
							readOnly
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-all">전체 사용자</label>
					</div>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
						<input
							name="receiver"
							id="receiver-targeting"
							type="radio"
							checked={clickedMeassageInfo["발송 대상자"]==="타겟팅"}
							readOnly
						/>
						<label className="formModalItem__input__radioLabel" htmlFor="receiver-targeting">타겟팅</label>
					</div>					
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">타겟 조건</div>
				<div>
					<div className="formModalItem__subItem" style={{ marginBottom: '1rem' }}>
						<div className="formModalItem__label">성별</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-male"
									type="radio"
									checked={clickedMeassageInfo.성별==="남"}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-male">남</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-female"
									type="radio"
									checked={clickedMeassageInfo.성별==="여"}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-female">여</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="targetGender"
									id="targetGender-all"
									type="radio"
									checked={clickedMeassageInfo.성별==="전체" && clickedMeassageInfo["발송 대상자"]==="타겟팅"}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="targetGender-all">전체</label>
							</div>					
						</div>
					</div>
					<div className="formModalItem__subItem">
						<div className="formModalItem__label">훈련</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-10"
									type="checkbox"
									checked={clickedMeassageInfo.훈련 && clickedMeassageInfo.훈련.includes("시작 전")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-10">시작 전</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-20"
									type="checkbox"
									checked={clickedMeassageInfo.훈련 && clickedMeassageInfo.훈련.includes("정상")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-20">정상</label>
							</div>					
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width" />
						</div>
						<div
							className="formModalItem__input"
							style={{width: '21.875rem', justifyContent: 'space-between', marginLeft: 0}}
						>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-40"
									type="checkbox"
									checked={clickedMeassageInfo.훈련 && clickedMeassageInfo.훈련.includes("미달")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-40">미달</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-45"
									type="checkbox"
									checked={clickedMeassageInfo.훈련 && clickedMeassageInfo.훈련.includes("탈락")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-45">탈락</label>
							</div>
							<div className="formModalItem__input__radio formModalItem__input__radio_limit_width">
								<input
									name="training"
									id="training-30"
									type="checkbox"
									checked={clickedMeassageInfo.훈련 && clickedMeassageInfo.훈련.includes("종료")}
									readOnly
								/>
								<label className="formModalItem__input__radioLabel" htmlFor="training-30">종료</label>
							</div>					
						</div>
					</div>
				</div>				
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">메시지</div>
				<div className="formModalItem__input">
					<textarea
						type="text"
						className="formModalItem__input__textarea"
						value={clickedMeassageInfo.내용}
						style={{ height: '12.5rem' }}
						readOnly
					/>
				</div>
			</div>
		</div>
	);

	// pagination
	const getNewTableDataByPagination = (page) => {
		setSelectedPage(page);
	}

	const handleClickMessageItem = (e) => {
		setClickedMessageInfo(e);
		setShowClickedMessageModal(true);
	}




	useEffect(()=>{
		setSelectedPage(1);
	},[])

	useEffect(()=>{
		getPushMessageFromAPI();
	},[selectedPage])

	useEffect(()=>{
		getPushMessageFromAPI();
	},[searchOption])

    return (
        <div>
        	<div className="dashboardContent">
                <div className="dashboardContent__title">
                    <span className="dashboardContent__title__content">단체 메시지</span>
                </div>
                <div className="dashboardContent__inner">
                    <div className="patientManageList">
                        <div className='patientManageList__search'>
                            <div className="SearchTablePage-Header">
                                <div className="Header-Title">검색 조건</div>
                                <div className="Header-Button">
                                    <button className="White" onClick={resetSearchOption}>초기화</button>
                                    <button className="Blue" onClick={applySearchOption}>검색</button>
                                </div>
                            </div>
                            <div className="SearchWrapper">
                                <div className="SearchBar">
                                    <span className="searchBar__label">검색</span>
                                    <input
                                        className="Search-Input"
                                        type="text"
                                        placeholder='보낸 사람, 기관명, 부서명, 내용'
                                        onChange={(e)=>setInputSearchOption({ ...inputSearchOption, search: e.target.value })}
                                        maxLength={50}
                                        value={inputSearchOption.search}
                                    />
                                    {hasForbiddenChars(inputSearchOption.search) && (
                                        <div className="validation" style={{ color: '#DC3545', marginTop: '0.5rem' }}>
                                            {FORBIDDEN_CHARS_MSG}
                                        </div>
                                    )}
                                </div>
                                {/* 단체 메시지 페이지 검색 조건 */}							
                                <div/>
                                <div className="SearchBar">
                                    <span className="searchBar__label">받는 사람</span>
                                    <div className="Radio-Row">
                                        <div className="Radio-Row-Item">
                                            <input
                                                id="notification-target-yes"
                                                name="patient-group"
                                                type="radio"
                                                onChange={()=>setInputSearchOption({
                                                    ...inputSearchOption,
                                                    target: "A",
													sex: "",
													training: ""
                                                })}
                                                checked={inputSearchOption.target === "A"}
                                            />
                                            <label htmlFor="notification-target-yes">전체 사용자</label>
                                        </div>
                                        <div className="Radio-Row-Item" />
                                        <div className="Radio-Row-Item">
                                            <input
                                                id="notification-target-no"
                                                name="patient-group"
                                                type="radio"
                                                onChange={()=>setInputSearchOption({
                                                    ...inputSearchOption,
                                                    target: "T"
                                                })}
                                                checked={inputSearchOption.target === "T"}
                                            />
                                            <label htmlFor="notification-target-no">타겟팅</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="SearchBar">
                                    <span className="searchBar__label">훈련</span>
                                    <div className="MultipleSearch">
                                        <div className="Radio-Row">
                                            <span> </span>
                                            <div className="Radio-Row-Item">
                                                <input
                                                    id="search-training-10"
                                                    name="search-training"
                                                    type="checkbox"
                                                    onChange={()=>handleCheckInputSearchOptionTraining("10")}
                                                    checked={inputSearchOption.training.includes('10')}
													disabled={inputSearchOption.target === "A"}
                                                />
                                                <label htmlFor="search-training-10">시작 전</label>
                                            </div>
                                            <div className="Radio-Row-Item">
                                                <input
                                                    id="search-training-20"
                                                    name="search-training"
                                                    type="checkbox"
                                                    onChange={()=>handleCheckInputSearchOptionTraining("20")}
                                                    checked={inputSearchOption.training.includes('20')}
													disabled={inputSearchOption.target === "A"}
                                                />
                                                <label htmlFor="search-training-20">정상</label>
                                            </div>
                                        </div>						
                                        <div className="Radio-Row">
                                            <span> </span>
                                            <div className="Radio-Row-Item">
                                                <input
                                                    id="search-training-40"
                                                    name="search-training"
                                                    type="checkbox"
                                                    onChange={()=>handleCheckInputSearchOptionTraining("40")}
                                                    checked={inputSearchOption.training.includes('40')}
													disabled={inputSearchOption.target === "A"}
                                                />
                                                <label htmlFor="search-training-40">미달</label>
                                            </div>
                                            <div className="Radio-Row-Item">
                                                <input
                                                    id="search-training-45"
                                                    name="search-training"
                                                    type="checkbox"
                                                    onChange={()=>handleCheckInputSearchOptionTraining("45")}
                                                    checked={inputSearchOption.training.includes('45')}
													disabled={inputSearchOption.target === "A"}
                                                />
                                                <label htmlFor="search-training-45">탈락</label>
                                            </div>
                                            <div className="Radio-Row-Item">
                                                <input
                                                    id="search-training-30"
                                                    name="search-training"
                                                    type="checkbox"
                                                    onChange={()=>handleCheckInputSearchOptionTraining("30")}
                                                    checked={inputSearchOption.training.includes('30')}
													disabled={inputSearchOption.target === "A"}
                                                />
                                                <label htmlFor="search-training-30">종료</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="SearchBar">
                                    <span className="searchBar__label">성별</span>
                                    <div className="Radio-Row">
                                        <div className="Radio-Row-Item">
                                            <input
                                                id="notification-sex-all"
                                                name="notification-sex"
                                                type="radio"
                                                onChange={()=>{
													setHasGenderClicked(true);
													setInputSearchOption({
                                                    ...inputSearchOption,
                                                    sex: "A"
                                                })
												}}
                                                checked={((inputSearchOption.sex === "A" || inputSearchOption.sex=== "") && hasGenderClicked) || inputSearchOption.target === "A"}
												disabled={inputSearchOption.target === "A"}
                                            />
                                            <label htmlFor="notification-sex-all">전체</label>
                                        </div>
                                        <div className="Radio-Row-Item">
                                            <input
                                                id="notification-sex-man"
                                                name="notification-sex"
                                                type="radio"
                                                onChange={()=>{
													setHasGenderClicked(true);
													setInputSearchOption({
                                                    ...inputSearchOption,
                                                    sex: "M"
                                                })
												}}
                                                checked={inputSearchOption.sex === "M"}
												disabled={inputSearchOption.target === "A"}
                                            />
                                            <label htmlFor="notification-sex-man">남</label>
                                        </div>
                                        <div className="Radio-Row-Item">
                                            <input
                                                id="notification-sex-female"
                                                name="notification-sex"
                                                type="radio"
                                                onChange={()=>{
														setHasGenderClicked(true);
														setInputSearchOption({
														...inputSearchOption,
														sex: "F"
													})
												}}
                                                checked={inputSearchOption.sex === "F"}
												disabled={inputSearchOption.target === "A"}
                                            />
                                            <label htmlFor="notification-sex-female">여</label>
                                        </div>
                                    </div>
                                </div>
                                <div/>
                            </div>
                        </div>
                        <div className="patientManageList__list">
                            <div className="SearchTablePage-Header">
                                <div className="Header-Title">메시지 리스트</div>
                                <div className="Header-Button">
                                    <button
                                        className="Blue"
                                        onClick={()=>setShowRegisterNotificationModal(true)}
                                    >
                                        메시지 보내기
                                    </button>						
                                </div>
                            </div>
                            <div className="table_wrapper" style={{ paddingTop: '1.25rem' }}>
                                <div className="table_count">총 {totalDataCnt}개</div>
                                <HearroCommonTable
                                    tableHeader={tableHeader}
                                    tableBody={pushMessageData}
                                    isClick
                                    clickEvent={handleClickMessageItem}
                                    isNumCol={false}
                                />
                                <CommonPagination
                                    pageCnt={Math.ceil(totalDataCnt/10) || 1}
                                    selectedPage={selectedPage}
                                    SetSelectedPage={setSelectedPage}
                                    GetNewTableData={getNewTableDataByPagination}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			{/* 메시지 전송 modal */}
			<CommonModal
				header="메시지 보내기"
				body={RegisterNotificationModalBody}
				footer={RegisterNotificationModalFooter}
				show={showRegisterNotificationModal}
				setClose={closeRegisterNotificationModal}
				size="lg"
			/>
			{/* 메시지 상세 보기 modal */}
			<CommonModal
				header="메시지"
				body={ClickedMessageModalBody}
				show={showClickedMessageModal}
				setClose={closeClickedMessageModal}
				size="lg"
			/>
			{/* 메시지 전송 성공 modal */}
			<CommonModal
				header="메시지 보내기"
				body={SuccessSendModalBody}
				footer={SuccessSendModalFooter}
				show={showSuccessSendModal}
				setClose={closeSuccessSendModal}
				size="sm"
			/>
		</div>
    );
}

export default HearroNotificationList;